<div class="advanced-audio-modes m-t-10">
  <a role="button" (click)="handleMenuClick()">
    <div class="title m-b-10 flex">
      <span>Advanced Settings</span>
      <svg
        [ngClass]="{ rotated: menuOpen }"
        width="24"
        height="24"
        style="float: right"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17L15 12L10 7V17Z" fill="#333333" />
      </svg>
    </div>
  </a>
  <!-- Default Full Screen -->
  @if (menuOpen) {
    <div data-testid="menu-items">
      <!-- Group Conversations -->
      @if (!groupConversationsV1) {
        <div class="toggle-item">
          <label class="toggle-item-label">
            Group conversations
            <mat-icon
              class="help-icon"
              svgIcon="help-icon"
              aria-hidden="false"
              arial-label="Info Icon"
              matTooltip="Disabling this will mute everyone in the audience and prevent them from talking to each other during the presentation."
              style="height: 20px; overflow: initial"
            ></mat-icon>
          </label>
          <div class="toggle-item-toggle">
            <mat-slide-toggle
              (toggleChange)="handleGroupConversationsChange()"
              [checked]="allowGroupConversations"
              class="toggle-item-toggle"
              data-testid="toggle-group-conversations"
              [disabled]="requireFullScreen"
            ></mat-slide-toggle>
          </div>
        </div>
      }
      <!-- Interaction Modes -->
      <div class="interaction-mode-group p-8 m-b-8">
        <mat-radio-group
          aria-labelledby="interaction-mode-label"
          [(ngModel)]="interactionMode"
          (change)="handleInteractionModeChange($event)"
        >
          <label class="interaction-mode-label">Audience Participation</label>
          @for (mode of availableInteractionModes; track trackModeByFn($index, mode)) {
            <div ngClass="mode-type m-b-8">
              <mat-radio-button
                [disabled]="isInteractionModeDisabled(mode.value)"
                [value]="mode.value"
                color="primary"
                [attr.data-testid]="mode.value"
              >
                {{ mode.label }}
              </mat-radio-button>
              <mat-icon
                class="help-icon"
                svgIcon="help-icon"
                aria-hidden="false"
                arial-label="Info Icon"
                matTooltip="{{
                  isInteractionModeDisabled(mode.value)
                    ? 'Turn Group Conversations on to enable this participation setting'
                    : mode.tooltip
                }}"
              ></mat-icon>
            </div>
          }
        </mat-radio-group>
      </div>
    </div>
  }
</div>
